import { Link } from 'react-router-dom';
import ScrollReveal from '@/components/base/ScrollReveal';

export default function DurabilityProof() {
  return (
    <section className="bg-secondary-200 py-14 md:py-20">
      <div className="max-w-none mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          {/* Left: Text */}
          <ScrollReveal direction="left" className="flex-1 w-full">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-primary-500 mb-4">
              Built to Keep Up.
            </h2>
            <p className="text-sm md:text-base text-foreground-600 font-label mb-6 max-w-md">
              We engineered Joviaa jewellery for women who never stop — because
              your gold shouldn&apos;t either.
            </p>
            <div className="flex flex-col gap-3">
              <div className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <div className="w-2 h-2 rounded-full bg-accent-500"></div>
                </div>
                <p className="text-sm md:text-base text-foreground-700 font-label">
                  <strong className="text-primary-500 font-heading">Sweat-tested</strong> — worn through workouts, commute, and long days. No tarnish.
                </p>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <div className="w-2 h-2 rounded-full bg-accent-500"></div>
                </div>
                <p className="text-sm md:text-base text-foreground-700 font-label">
                  <strong className="text-primary-500 font-heading">Water-resistant</strong> — light splashes, hand-washing, rain. No green skin, no fading.
                </p>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <div className="w-2 h-2 rounded-full bg-accent-500"></div>
                </div>
                <p className="text-sm md:text-base text-foreground-700 font-label">
                  <strong className="text-primary-500 font-heading">Daily-wear tested</strong> — 30-day continuous wear tests. Still looks like day one.
                </p>
              </div>
            </div>
            <Link
              to="/durability"
              className="inline-block mt-7 px-6 py-3 border-2 border-primary-500 text-primary-500 rounded-full font-heading font-semibold text-sm hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
            >
              See Our Tests
            </Link>
          </ScrollReveal>

          {/* Right: Video */}
          <ScrollReveal direction="right" delay={150} className="flex-1 w-full">
            <div className="relative aspect-video rounded-2xl overflow-hidden bg-primary-500 max-w-lg mx-auto lg:max-w-none">
              <video
                src="https://storage.readdy-site.link/project_files/4ae51fa3-40da-40a1-b133-2a5cd9cb4858/6be57786-4be6-4d97-b77a-d12aa996d2e3_built-to-last.mp4"
                autoPlay
                loop
                muted
                playsInline
                className="w-full h-full object-cover"
              />
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}